(() => {
  const SIZE_NAMES = new Set(['size', '尺码', '尺寸']);
  let sizeChosen = false;
  let enforceTimer = 0;

  const normalize = (value) => (value || '').trim().toLowerCase();

  function findMainPicker() {
    const pickers = Array.from(document.querySelectorAll('variant-picker'));
    return pickers.find((picker) => {
      const section = picker.closest('.shopify-section');
      return section && section.querySelector('product-form-component');
    }) || pickers[0] || null;
  }

  function findSizeOption(picker) {
    if (!picker) return null;

    for (const fieldset of picker.querySelectorAll('fieldset')) {
      const legend = fieldset.querySelector('legend');
      if (SIZE_NAMES.has(normalize(legend?.textContent))) return fieldset;
    }

    for (const wrapper of picker.querySelectorAll('.variant-option')) {
      const label = wrapper.querySelector(':scope > label');
      if (SIZE_NAMES.has(normalize(label?.textContent))) return wrapper;
    }

    return null;
  }

  function findProductForm(picker) {
    const section = picker?.closest('.shopify-section');
    return section?.querySelector('product-form-component') || document.querySelector('product-form-component');
  }

  function clearSizeSelection(sizeOption) {
    sizeOption.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.checked = false;
      input.removeAttribute('checked');
    });

    sizeOption.querySelectorAll('select').forEach((select) => {
      select.selectedIndex = -1;
      Array.from(select.options).forEach((option) => {
        option.selected = false;
        option.removeAttribute('selected');
      });
    });
  }

  function setButtonWaiting(form) {
    const variantInput = form.querySelector('[ref="variantId"], input[name="id"]');
    if (variantInput) variantInput.value = '';

    const button = form.querySelector('[ref="addToCartButton"]');
    if (button) {
      button.disabled = true;
      button.setAttribute('disabled', 'true');
      button.setAttribute('aria-disabled', 'true');
      const text = button.querySelector('.add-to-cart-text__content');
      if (text) text.textContent = 'Select a size';
    }

    const accelerated = form.querySelector('[ref="acceleratedCheckoutButtonContainer"]');
    if (accelerated) {
      accelerated.hidden = true;
      accelerated.setAttribute('hidden', 'true');
    }
  }

  function enforceRequiredSize() {
    if (sizeChosen) return;

    const picker = findMainPicker();
    const sizeOption = findSizeOption(picker);
    if (!sizeOption) return;

    clearSizeSelection(sizeOption);

    const form = findProductForm(picker);
    if (form) setButtonWaiting(form);
  }

  function scheduleEnforce(delay = 0) {
    if (sizeChosen) return;
    window.clearTimeout(enforceTimer);
    enforceTimer = window.setTimeout(enforceRequiredSize, delay);
  }

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const picker = target.closest('variant-picker');
    if (!picker) return;

    const sizeOption = findSizeOption(picker);
    if (!sizeOption) return;

    if (sizeOption.contains(target)) {
      sizeChosen = true;
      return;
    }

    scheduleEnforce(100);
  }, true);

  document.addEventListener('variant:update', () => {
    if (!sizeChosen) scheduleEnforce(0);
  }, true);

  window.addEventListener('pageshow', () => scheduleEnforce(0));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      scheduleEnforce(0);
      window.setTimeout(enforceRequiredSize, 100);
    }, { once: true });
  } else {
    scheduleEnforce(0);
    window.setTimeout(enforceRequiredSize, 100);
  }
})();
